
const API = {
    path: "/sriaccess/nws.pl",
};
export default API;